const techStack = [
  {
    tag: "Lang",
    image: "html.png",
  },
  {
    tag: "Lang",
    image: "css.png",
  },
  {
    tag: "Lang",
    image: "js.png",
  },
  {
    tag: "Framework",
    image: "react.png",
  },
  {
    tag: "Framework",
    image: "reactnative.png",
  },
  {
    tag: "Framework",
    image: "bootstrap.png",
  },
  {
    tag: "Lang",
    image: "cpp.png",
  },
  {
    tag: "Lang",
    image: "python.png",
  },
  {
    tag: "Lang",
    image: "node.png",
  },
  {
    tag: "Framework",
    image: "express.png",
  },
  {
    tag: "Lang",
    image: "mongo.png",
  },
  {
    tag: "Lang",
    image: "mysql.png",
  },
  {
    tag: "Tool",
    image: "figma.png",
  },
  {
    tag: "Tool",
    image: "code.png",
  },
  {
    tag: "Tool",
    image: "github.png",
  },
  {
    tag: "Tool",
    image: "git.png",
  },
  {
    tag: "Tool",
    image: "postman.png",
  },
  {
    tag: "Framework",
    image: "tailwind.png",
  },
];

module.exports = { techStack };
